import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";
import Head from "next/head";
import ShowAllProducts from "@/components/ShowAllProducts";
const Loader = dynamic(() => import("@/components/loader"));

const LandingPage = ({
  locale = "en",
  params = {},
  compareMappingsData = {},
}) => {
  const router = useRouter();
  if (router.isFallback) {
    return <Loader loading={router.isFallback} />;
  }
  const slugKey = Array.isArray(params?.slug)
    ? params.slug.join("/")
    : params?.slug || "";

  const pageTitle = `${slugKey.charAt(0).toUpperCase() + slugKey.slice(1)} | Kohler`;
  return (
    <>
      <Head>
        <title>{`${pageTitle}`}</title>
      </Head>
      <ShowAllProducts
        params={params}
        locale={locale}
        key={locale}
        compareMappingsData={compareMappingsData}
      />
    </>
  );
};

export async function getServerSideProps({ req, params, preview }) {
  const { slug = "/" } = params;
  const {
    items,
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
    compareMappingsData,
  } = await getPageShellDataSafely({
    slug: `/browse/${slug}`,
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: true,
  });

  return {
    props: {
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
      compareMappingsData,
      params,
    },
  };
}

LandingPage.propTypes = {
  pageData: PropTypes.object,
  locale: PropTypes.string,
  plpData: PropTypes.object,
  facetLabelsState: PropTypes.object,
  categoryConfig: PropTypes.string,
  params: PropTypes.object,
  compareMappingsData: PropTypes.object,
};

export default LandingPage;
